





















import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import * as api from '@/api';
import * as models from '@/api/models';
import { Toast } from 'vant';
import experienceList from '@/views/myExperience/component/experienceList.vue';
@Component({
  components: { experienceList },
})
export default class Leave extends Vue {
  activeName: string = '已提交';
  experienceStatus: string = '已提交';
  stateSwtich(name: string) {
    this.experienceStatus = name;
  }
}
